export default __webpack_public_path__ + "static/media/icon-checkmark-hover-light.99df962b.svg";